import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "../http.service";
import { CancelListResponse, CancelRecord } from "../../../models/admin/orders.model";
import { cancelInput, Coupon, OrderListResponse, SeoCategoryKeywordsInput, SeoCategoryKeywordsResponse, SubmitResponse } from "@sgm-frontend/core";
import { CouponInputPayload, CouponInputStatusPayload, CouponListResponse, CouponStatusCountResponse } from "../../../models/admin/coupons.model";


@Injectable({
    providedIn: 'root'
})
export class SeoKeywordsService extends HttpService<any | cancelInput, SeoCategoryKeywordsResponse> {
    private seoListSubject = new BehaviorSubject<SeoCategoryKeywordsResponse | null>(null);
    readonly seolList$ = this.seoListSubject.asObservable();

    constructor(
        httpClient: HttpClient,
        @Inject('API_URL') apiUrl: string,
        @Inject('API_VERSION') apiVersion: string
    ) {
        super(httpClient, apiUrl, apiVersion, 'category/keywords');
    }

    getAllSeoKeywords(page = 1, limit = 10): Observable<SeoCategoryKeywordsResponse | null> {
        return this.getPagedGeneral('category/keywords/list', page, limit).pipe(
            tap(response => this.seoListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    getFilteredSeoKeywords(entity: any): Observable<SeoCategoryKeywordsResponse | null> {
        return this.getBy('search',entity).pipe(
            tap((response) => this.seoListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    deleteSeoCategoryKeyword(seoCatId: string): Observable<SubmitResponse> {
        return this.delete(seoCatId);
    }
    createSeoKeywords(couponInput: CouponInputPayload): Observable<SubmitResponse> {
        return this.create(couponInput).pipe(catchError((error) => of(error)));
    }
    getSeoKeywordsById(couponId: string): Observable<Coupon> {
        return this.getById(couponId).pipe(catchError((error) => of(error)));
    }
    updateSeoKeywords(keywordInput: SeoCategoryKeywordsInput): Observable<SubmitResponse> {
        return this.update(keywordInput).pipe(catchError((error) => of(error)));
    }
    // statusCoupon(couponInput: CouponInputStatusPayload,id:string): Observable<SubmitResponse> {
    //     return this.update(couponInput,"status/"+id).pipe(catchError((error) => of(error)));
    // }
    // getStatus(): Observable<CouponStatusCountResponse | null> {
    //     return this.getAll('status-counts').pipe(catchError((error) => of(error)));
    // }

}